import React, { FC } from 'react';

import Link from 'next/link';

import { useTranslate } from '@/hooks/use-translate';

import { en } from '../en';
import { RouteData } from '../types';

import styles from '../NewApplicationFork.module.scss';

type Props = {
	route: RouteData;
	authed?: boolean;
};

export const EnabledElement: FC<Props> = ({ route, authed }) => {
	const t = useTranslate(en);

	return (
		<>
			<div className={styles.icon}>{route.icon}</div>
			<div className={styles.descriptionBlock}>
				<span className={styles.newAppForkApplication}>{t(route.name)}</span>
				<span className={styles.description}>{t(route.description)}</span>
			</div>
			<Link className={styles.newAppForkLink} href={!authed ? '/login' : route.path} />
		</>
	);
};
